(() => {
  if (customElements.get('nfx-watermark')) return;
  class Watermark extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.host = this.parentElement;
      this.image = this.host.querySelector('img[data-nfx-product-image]');
      if (!this.image) return;
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.place(); }); };
      this.observer = new ResizeObserver(this.queue);
      this.observer.observe(this.host);
      this.observer.observe(this.image);
      this.image.addEventListener('load', this.queue, {signal:this.abort.signal});
      window.addEventListener('resize', this.queue, {signal:this.abort.signal,passive:true});
      this.queue();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    place() {
      const imageBox = this.image.getBoundingClientRect();
      const hostBox = this.host.getBoundingClientRect();
      if (!imageBox.width || !imageBox.height) return;
      const ratio = Number(this.image.getAttribute('width')) / Number(this.image.getAttribute('height')) || this.image.naturalWidth / this.image.naturalHeight || 1;
      const style = getComputedStyle(this.image);
      let width = imageBox.width, height = imageBox.height;
      if (style.objectFit === 'contain') {
        width = Math.min(imageBox.width, imageBox.height * ratio);
        height = width / ratio;
      }
      const x = imageBox.left + (imageBox.width - width) / 2;
      const y = imageBox.top + (imageBox.height - height) / 2;
      const fixed = this.host.matches('dialog[data-zoom-dialog]');
      this.style.position = fixed ? 'fixed' : 'absolute';
      if (fixed) {
        const left = Math.max(x,hostBox.left + this.host.clientLeft);
        const top = Math.max(y,hostBox.top + this.host.clientTop);
        width = Math.min(x + width,hostBox.left + this.host.clientLeft + this.host.clientWidth) - left;
        height = Math.min(height,this.host.clientHeight);
        this.style.left = left + 'px';
        this.style.top = top + 'px';
      } else {
        this.style.left = x - hostBox.left - this.host.clientLeft + 'px';
        this.style.top = y - hostBox.top - this.host.clientTop + 'px';
      }
      this.style.width = Math.max(0,width) + 'px';
      this.style.height = Math.max(0,height) + 'px';
      this.setAttribute('data-placed','');
    }
  }
  customElements.define('nfx-watermark',Watermark);
  const imageAt = event => event.target instanceof Element ? event.target.closest('norifox-product img[data-nfx-product-image]') : null;
  document.addEventListener('contextmenu',event=>{if(imageAt(event))event.preventDefault();});
  document.addEventListener('dragstart',event=>{if(imageAt(event))event.preventDefault();});
  document.addEventListener('click',event=>{
    const image=imageAt(event),link=image?.closest('a');
    if(link && /\.(?:avif|webp|png|jpe?g|gif)(?:\?|$)/i.test(link.href))event.preventDefault();
  });
})();
